import { render, staticRenderFns } from "./JiraImport.vue?vue&type=template&id=5ed23825&scoped=true&"
import script from "./JiraImport.vue?vue&type=script&lang=js&"
export * from "./JiraImport.vue?vue&type=script&lang=js&"
import style0 from "./JiraImport.vue?vue&type=style&index=0&id=5ed23825&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed23825",
  null
  
)

export default component.exports